/*eslint-disable*/
import { createAsyncThunk } from "@reduxjs/toolkit";
import service from "./service";
import claim_service from "../../Claim/services/claim_service";
import { getStorage } from "../../../../utilities/browserStorage";
import { DEFAULT_PAGING_SIZE } from "../../../../utilities/staticConfigs";
import i18n from "../../../../utilities/i18n";
import { buildAllChangedFieldsPayload, createPatientSaveData, patientValidationMiddleware, validatePatientData } from "./patientDataProcessor";


export const getRenderingProviders = createAsyncThunk(
    "patient/renderingproviders",
    async (pk) => {
        const praticePK = getStorage("practice");
        const result = await service.ListRenderingProviders(20, 0, praticePK, pk);
        return result.data;
    });


export const getAllSelectInput = createAsyncThunk(
    'patientbeta/selectInput',
    async (payload, thunkAPI) => {
        const pageSize = DEFAULT_PAGING_SIZE;
        const page = 0;
        const practicePK = getStorage('practice');
        const patientPK = payload.patientPK ?? ""

        const promises = [
            service.ListReferringProviders(pageSize, page, practicePK, patientPK).then(response => response.data),
            service.ListRenderingProviders(pageSize, page, practicePK, patientPK).then(response => response.data),
            service.ServiceLocationLists(practicePK, patientPK).then(response => {
                let locations = []
                response.data.map((item) => {
                    item.id = item.Id + '||' + item.location_type
                    locations.push(item)
                })
                return locations
            }),
            service.ListPatientTypes(
                pageSize,
                page,
                practicePK,
                patientPK
            ).then(response => response.data),

            service.ListLanguages(
                pageSize,
                page,
                practicePK,
                patientPK
            ).then(response => response.data),
            service.ListRelationShips(pageSize, page, patientPK, "info").then(response => response.data),
            service.ListReferringProviderGroups(
                pageSize,
                page,
                practicePK,
                patientPK
            ).then(response => response.data),

            service.ListTypeOfAccident(
                DEFAULT_PAGING_SIZE,
                patientPK
            ).then(response => response.data),

            service.ListAccidentLocation().then(response => response.data),
        ]
        try {
            const [
                referringProvider,
                renderingProvider,
                serviceLocations,
                patientTypes,
                languagesList,
                relationList,
                referringProviderGroupList,
                typeOfAccident,
                listOfLocation
            ] = await Promise.all(promises);

            return {
                renderingProvider,
                referringProvider,
                serviceLocations,
                patientTypes,
                languagesList,
                relationList,
                referringProviderGroupList,
                typeOfAccident,
                listOfLocation
            };

        } catch (error) {
            return thunkAPI.rejectWithValue({ errorMessage: 'Error getting Drop-down list data!' })
        }
    }
)


/**
 * api call for get selected patient Details
 * @param {*} payload
 */
export const getPatientBasicDetails = createAsyncThunk(
    "patient/patientbasicdetails",
    async (payload, thunkAPI) => {
        let isInsurance = 0;
        /**
         * api call to get patient basic info detais
         * @param {*} pk
         */
        const resultPatientAdd = await service.getPatientData(payload.pk);
        const response = await service.ListInsuranceInfos(payload.pk);
        if (response.data?.length)
            isInsurance = true;
        else
            isInsurance = false;
        /**
         * api call to get patient all info details
         * @param {*} pk
         */
        const resultPatientInfo = await getPatientotherDetails(
            resultPatientAdd.data.detail_ids.patient_info
        );

        /**
         * api call to get patient all other billing details
         * @param {*} pk
         */
        const { resultotherBilling, assignmentBenifit } = await getPatientotherBillingData(
            resultPatientAdd?.data?.detail_ids?.billing_info, DEFAULT_PAGING_SIZE, payload.pk
        );

        const { claimbeta } = thunkAPI.getState();
        const { permitted_fields } = claimbeta?.professionalClaimDetails ?? {};

        return {
            patientAddVariables: resultPatientAdd.data,
            patientInfoVariables: resultPatientInfo.data,
            patientOtherBilling: resultotherBilling,
            assignmentBenifit: assignmentBenifit,
            pk: payload.pk,
            infopk: resultPatientAdd.data.detail_ids.patient_info,
            isInsurance: isInsurance,
            permitted_fields: permitted_fields?.demographics ?? {}
        };
    }
);

/**
 * api call for get selected patient Details
 * @param {*} pk
 */
export const getPatientotherDetails = async (PK) => {
    /**
     * calling api for getting all patient info data
     */
    const res = await service.getPatientInfoData(PK);
    return { data: res.data };
};

/**
 * api call for get selected patient Details
 * @param {*} pk
 */
export const getPatientotherBillingData = async (id, page, pk) => {
    /**
     * calling api for getting all patient info data
     */
    const result1 = await service.GetOtherBillingInfoData(id);
    let result2 = await service.ListTypeOfAssignmentBenefits(page, pk)
    return { resultotherBilling: result1.data, assignmentBenifit: result2.data };
};


export const activatePatient = createAsyncThunk(
    'patientbeta/activatePatient',
    async ({ patientPK, patientInactive }, { rejectWithValue }) => {
        try {
            // Execute the service call
            const active_result = await service.UpdatePatientActive(patientPK, { active: patientInactive });
            if (active_result.data) {
                return active_result.data;
            } else {
                return rejectWithValue(i18n.t("errorMessages.commonError"));
            }
        } catch (error) {
            return rejectWithValue(i18n.t("errorMessages.commonError"));
        }
    }
);


export const fetchMergePatients = createAsyncThunk(
    'patientbeta/fetchMergePatients',
    async (queryParams, { rejectWithValue }) => {
        try {
            const result = await service.ListPatients(queryParams);
            return result.data.results;
        } catch (error) {
            return rejectWithValue(i18n.t("errorMessages.commonError"));
        }
    }
);


export const validatePatients = createAsyncThunk(
    'patientbeta/validatePatients',
    async ({ sourceIds, targetId }, { dispatch, rejectWithValue }) => {
        try {

            if (sourceIds.length == 0) {
                return rejectWithValue(i18n.t("patientPages.patients.patientMergeRestrict"));
            }

            const validateData = {
                source_patient_ids: sourceIds,
                target_patient_id: targetId
            };
            const response = await service.PatientValidate(validateData);
            if (response.status == 200) {
                dispatch(mergePatients({ sourceIds: sourceIds, targetId: targetId, mergeWithWarning: true }))
                return { data: response.data, status: 200 }
            } else if (response.status == 400 && response.data.message == "procedure_conflict") {
                return rejectWithValue(i18n.t("patientPages.patients.duplicateRestriction"));
                } else if (response.status == 409) {
                return { data: {}, status: 409 };
            } else {
                return rejectWithValue(i18n.t("errorMessages.commonError"));
            }
        } catch (error) {
            return rejectWithValue(i18n.t("errorMessages.commonError"));
        }
    }
);


export const mergePatients = createAsyncThunk(
    'patientbeta/mergePatients',
    async ({ sourceIds, targetId, mergeWithWarning }, { rejectWithValue }) => {
        try {
            const mergeData = {
                source_patient_ids: sourceIds,
                target_patient_id: targetId,
                merge_with_payment_plan: mergeWithWarning
            };

            const response = await service.MergePatient(mergeData);
            if (response?.status === 200) {
                return { data: response?.data, status: response.status }
            } else if (response.status === 400 && response.data?.message === "multiple_alert_exists") {
                return rejectWithValue(i18n.t("patientPages.patients.multipleAlertError"));
            } else {
                return rejectWithValue(i18n.t("errorMessages.commonError"));
            }
        } catch (error) {
            // Return the error data to check for 'multiple_alert_exists'
            return rejectWithValue(i18n.t("errorMessages.commonError"));
        }
    }
);


export const fetchCPTCodes = createAsyncThunk(
    'patientMerge/fetchCPTCodes',
    async ({ query, practicePK }, { rejectWithValue }) => {
        try {
            const type = "dropdown";
            const page = 0;
            const page_size = 0;

            const response = await service.GetCPTList(page_size, page, practicePK, type, query);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Error fetching CPT codes');
        }
    }
);

export const fetchICDCodes = createAsyncThunk(
    'patientMerge/fetchICDCodes',
    async ({ query, practicePK }, { rejectWithValue }) => {
        try {
            const type = "dropdown";
            const page = 0;
            const page_size = 0;

            const response = await service.GetICD10List(page_size, page, practicePK, type, query);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Error fetching ICD-10 codes');
        }
    }
);


export const fetchBillingCodesOnBlur = createAsyncThunk(
    'billing/fetchCodesOnBlur',
    async ({ value, name, searchType, practicePK }, { rejectWithValue }) => {
        try {
            const type = "dropdown";
            const page = 0;
            const page_size = 0;

            // Determine the search value from the event or string
            const rawValue = value ?? (typeof e === 'string' ? e : "");

            let response;
            if (searchType === "CPTCODE") {
                response = await service.GetCPTList(page_size, page, practicePK, type, rawValue);
            } else {
                const input_value = rawValue.toUpperCase();
                response = await service.GetICD10List(page_size, page, practicePK, type, input_value);
            }

            // We only return data if exactly one result is found (matching your original logic)
            if (Array.isArray(response.data) && response.data.length === 1) {
                return { name, data: response.data };
            }

            return { name, data: null }; // No unique match found
        } catch (error) {
            return rejectWithValue(error.response?.data || "API Error");
        }
    }
);


export const getPatientLedgerData = createAsyncThunk(
    'patient/getLedgerData',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await service.getPatientLedgerSummary(payload.patientId);
            return { data: response.data, patientId: payload.patientId }; // This becomes the action.payload
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

/**
 * APi to get ar claims
 */
export const getCptCodesForClaim = createAsyncThunk(
    "patient/getCptCodesForClaim",
    async (payload, { rejectWithValue }) => {
        let { claim_id, index } = payload
        try {
            let response = await service.GetARClaimProcedureList(claim_id);
            return { data: response.data, index: index, id: claim_id };
        } catch (error) {
            return rejectWithValue({ message: i18n.t("errorMessages.commonError") })
        }
    }
);

/**
 * APi to get ar claims
 */
export const getActivityOfProcedure = createAsyncThunk(
    "patient/getActivityOfProcedure",
    async (payload, { rejectWithValue }) => {
        let { id, index, main_index } = payload
        try {
            let response = await service.GetARClaimActivityOfProcedure(id);
            return { data: response.data, index: index, id: id, main_index: main_index };
        } catch (error) {
            return rejectWithValue({ message: i18n.t("errorMessages.commonError") })
        }
    }
);


export const patientPaymentSummary = createAsyncThunk(
    'patient/patientSummary',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await service.GetPatientPaymentSummaryDetails(
                payload
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return rejectWithValue(i18n.t("errorMessages.commonError"));
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || i18n.t("errorMessages.commonError"));
        }
    }
);

export const patientCreditBalanceView = createAsyncThunk(
    'patient/patientCreditBalanceView',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await service.GetCreditBalanceView(
                payload
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return rejectWithValue(i18n.t("errorMessages.commonError"));
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || i18n.t("errorMessages.commonError"));
        }
    }
);


export const patientLedgerSummary = createAsyncThunk(
    'patient/patientLedgerSummary',
    async ({patientId,includeInactive}, { rejectWithValue }) => {
        try {
            const response = await service.getPatientLedgerSummary(
                patientId,includeInactive
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return rejectWithValue(i18n.t("errorMessages.commonError"));
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || i18n.t("errorMessages.commonError"));
        }
    }
);

export const getPatientLedgerList = createAsyncThunk(
    'patient/getPatientLedgerList',
    async (patientID, { rejectWithValue }) => {
        try {
            const response = await service.GetPatientLederList(patientID);
            if (response.status === 200) {
                return response.data;
            } else {
                return rejectWithValue(i18n.t("errorMessages.commonError"));
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || i18n.t("errorMessages.commonError"));
        }
    }
);

export const loadClaimProcedures = createAsyncThunk(
    'patient/loadClaimProcedures',
    async (claimId, { rejectWithValue }) => {
        try {
            const response = await claim_service.GetARClaimProcedureList(claimId);
            return {
                claimId,
                procedures: response?.data || []
            };
        } catch (error) {
            return rejectWithValue({
                claimId,
                error: error.response?.data || i18n.t("errorMessages.commonError")
            });
        }
    }
);

export const loadProcedureActivities = createAsyncThunk(
    'patient/loadProcedureActivities',
    async ({ claimId, procedureId }, { rejectWithValue }) => {
        try {
            const response = await claim_service.GetARClaimActivityOfProcedure(procedureId);
            return {
                claimId,
                procedureId,
                activities: response?.data || []
            };
        } catch (error) {
            return rejectWithValue({
                claimId,
                procedureId,
                error: error.response?.data || i18n.t("errorMessages.commonError")
            });
        }
    }
);

export const updatePatientData = createAsyncThunk(
    'patient/updatePatientData',
    async ({ pk, isClose }, { rejectWithValue, getState, dispatch }) => {
        try {
            const state = getState();
            let { patientbeta } = state;
            let { patientBasicInfo, patientInfoData, otherBillingDetails,
                renderingProvider, diagnosisesValidated, diagnosisduplicated, cptduplicated, cptValidated } = patientbeta

            // operations like .toISOString() or comparison constraints don't throw errors.
            const sanitizedBasicInfo = {
                ...patientBasicInfo,
                date_of_birth: patientBasicInfo?.date_of_birth ? new Date(patientBasicInfo.date_of_birth) : null,
                date_of_death: patientBasicInfo?.date_of_death ? new Date(patientBasicInfo.date_of_death) : null
            };

            const validation = validatePatientData(sanitizedBasicInfo, patientInfoData, otherBillingDetails, renderingProvider);

            if (validation.isValid == false) {
                return rejectWithValue({ message: validation?.message ?? "" })
            }

            const { isError, errorMessage,
                patientInfoValidEmail,
                patientInfoValidEmergencyEmail,
                patientInfoValidGuarantorEmail } =
                patientValidationMiddleware(
                    sanitizedBasicInfo, patientInfoData, pk,
                    diagnosisesValidated, cptduplicated, cptValidated, diagnosisduplicated,
                    renderingProvider);

            if (isError) {
                return rejectWithValue({
                    message: errorMessage ?? "",
                    patientInfoValidEmail,
                    patientInfoValidEmergencyEmail,
                    patientInfoValidGuarantorEmail
                })
            }

            const patientBasicInfoData = buildAllChangedFieldsPayload(patientbeta, "patientBasicInfo");
            const patientInfo = buildAllChangedFieldsPayload(patientbeta, "patientInfoData");
            const otherBillingData = buildAllChangedFieldsPayload(patientbeta, "otherBillingDetails");
            const isPatientBasicDataEmpty = Object.keys(patientBasicInfoData?.patientBasicInfo || {}).length === 0;
            const isPatientInfoDataEmpty = Object.keys(patientInfo?.patientInfoData || {}).length === 0;
            const isOtherBillingDataEmpty = Object.keys(otherBillingData?.otherBillingDetails || {}).length === 0;

            if (isPatientBasicDataEmpty && isPatientInfoDataEmpty && isOtherBillingDataEmpty) {
                return rejectWithValue({ isopen: true, message: i18n.t("claim_beta.api_errors.no_data_to_save"), status: "error",isClose:isClose })
            }


            let reqData = createPatientSaveData(
                patientBasicInfoData?.patientBasicInfo,
                patientInfo?.patientInfoData,
                otherBillingData?.otherBillingDetails,
                renderingProvider, sanitizedBasicInfo
            );

            let response = await service.UpdatePatient(pk, reqData);

            if (response.status == 200) {
                if (!isClose) {
                    dispatch(getPatientBasicDetails({ pk: pk }))
                }
                return { data: response.data, isClose,active:reqData?.active ?? true };
            }

            if (response.status === 400 && response.data?.error === "zip_phone_validation_error") {
                return rejectWithValue({
                    message: response.data.message
                });
            }

            if (response.data?.message === "unique_patient") {
                return rejectWithValue({
                    message: i18n.t("errorMessages.unique_patient")
                });
            }

            return rejectWithValue({
                message: response?.data?.message || i18n.t("errorMessages.commonError")
            });
        } catch (error) {
            return rejectWithValue(i18n.t("errorMessages.commonError"));
        }
    }
);